"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMenuItemsFilter = void 0;
const UPGRADE_TO_CONSULTANT_KEY = 'become-consultant';
const UPGRADE_TO_BRAND_PARTNER_KEY = 'upgrade-to-brand-partner';
const filterMenuItems = (items, isDesktop) => isDesktop ? items : items.filter(x => !x.url?.includes(UPGRADE_TO_CONSULTANT_KEY) && !x.url?.includes(UPGRADE_TO_BRAND_PARTNER_KEY));
const findUrl = (menuItems, key) => menuItems.find(x => x.url?.includes(key))?.url ?? '';
const useMenuItemsFilter = (items, isDesktop) => ({
  filteredItems: filterMenuItems(items, isDesktop),
  upgradeToConsultantUrl: findUrl(items, UPGRADE_TO_CONSULTANT_KEY),
  upgradeToBrandPartnerUrl: findUrl(items, UPGRADE_TO_BRAND_PARTNER_KEY)
});
exports.useMenuItemsFilter = useMenuItemsFilter;
